export const searchCodes = [
  {
    code: '',
    name: '全部',
    category: '',
  },
  {
    code: '01',
    name: '专利',
    category: 'goods',
    iconfont: 'icon-zhuanli',
    supplyiconfont: 'icon-supply-patent',
    childs: [
      { code: '01001', name: '发明' },
      { code: '01002', name: '实用新型' },
      { code: '01003', name: '外观设计' },
    ],
  },
  {
    code: '02',
    name: '技术',
    category: 'goods',
    iconfont: 'icon-jishuchengguo',
    supplyiconfont: 'icon-supply-tech',
    childs: [
      { code: '01', name: '电子信息' },
      { code: '02', name: '生物与新医药' },
      { code: '03', name: '航空航天' },
      { code: '04', name: '新材料' },
      { code: '05', name: '高技术服务' },
      { code: '06', name: '新能源与节能' },
      { code: '07', name: '资源与环境' },
      { code: '08', name: '先进制造与自动化' },
      { code: '99', name: '其他' },
    ],
  },
  {
    code: '03',
    name: '服务',
    category: 'goods',
    iconfont: 'icon-service',
    supplyiconfont: 'icon-supply-service',
    childs: [
      { code: '03001', name: '法务服务' },
      { code: '03002', name: '知识产权服务' },
      { code: '03003', name: '金融服务' },
      { code: '03004', name: '技术经纪服务' },
      { code: '03005', name: '创业孵化服务' },
    ],
  },
  {
    code: '04',
    name: '需求',
    category: 'demand',
    iconfont: 'icon-xuqiu1',
    supplyiconfont: 'icon-supply-demand',
    childs: [
      // {
      //     code: '00',
      //     name: '专利'
      // },
      // {
      //     code: '01',
      //     name: '技术成果'
      // },
      // {
      //     code: '02',
      //     name: '专利/技术成果'
      // },
      // {
      //     code: '03',
      //     name: '其他需求'
      //     //name: '众包需求'
      // }
      {
        name: '关键技术研发',
        code: '00',
      },
      {
        name: '产品升级',
        code: '01',
      },
      {
        name: '技术改造',
        code: '02',
      },
      {
        name: '设备改进',
        code: '03',
      },
      {
        name: '技术交易',
        code: '04',
      },
      {
        name: '技术咨询',
        code: '05',
      },
      {
        name: '海外创新合作',
        code: '06',
      },
      {
        name: '科技金融',
        code: '07',
      },
      {
        code: '10',
        name: '测试参数',
      },
      {
        code: '11',
        name: '测试方法',
      },
      {
        code: '12',
        name: '测试设备',
      },
      {
        code: '13',
        name: '测试标准',
      },
      {
        code: '99',
        name: '其他',
      },
    ],
  },
  // {
  //     code: '05',
  //     name: '专家',
  //     category: 'expert',
  //     childs: [
  //         {
  //             code: '00',
  //             name: '专家'
  //         },
  //         {
  //             code: '01',
  //             name: '技术经理人'
  //         }
  //     ]
  // },
  {
    code: '06',
    name: '店铺',
    category: 'shop',
    childs: [],
  },
  {
    code: '07',
    name: '资讯',
    category: 'information',
    childs: [],
  },
];

export const searchCodes2 = [
  {
    code: '',
    name: '全部',
    category: '',
  },
  {
    code: '02',
    name: '成果',
    category: 'goods',
    iconfont: 'icon-jishuchengguo',
    supplyiconfont: 'icon-supply-tech',
    childs: [
      { code: '01', name: '电子信息' },
      { code: '02', name: '生物与新医药' },
      { code: '03', name: '航空航天' },
      { code: '04', name: '新材料' },
      { code: '05', name: '高技术服务' },
      { code: '06', name: '新能源与节能' },
      { code: '07', name: '资源与环境' },
      { code: '08', name: '先进制造与自动化' },
      { code: '99', name: '其他' },
    ],
  },
  {
    code: '04',
    name: '需求',
    category: 'demand',
    iconfont: 'icon-xuqiu1',
    supplyiconfont: 'icon-supply-demand',
    childs: [
      // {
      //     code: '00',
      //     name: '专利'
      // },
      // {
      //     code: '01',
      //     name: '技术成果'
      // },
      // {
      //     code: '02',
      //     name: '专利/技术成果'
      // },
      // {
      //     code: '03',
      //     name: '其他需求'
      //     //name: '众包需求'
      // }
      {
        name: '关键技术研发',
        code: '00',
      },
      {
        name: '产品升级',
        code: '01',
      },
      {
        name: '技术改造',
        code: '02',
      },
      {
        name: '设备改进',
        code: '03',
      },
      {
        name: '技术交易',
        code: '04',
      },
      {
        name: '技术咨询',
        code: '05',
      },
      {
        name: '海外创新合作',
        code: '06',
      },
      {
        name: '科技金融',
        code: '07',
      },
    ],
  },
  // {
  //     code: '05',
  //     name: '专家',
  //     category: 'expert',
  //     childs: [
  //         {
  //             code: '00',
  //             name: '专家'
  //         },
  //         {
  //             code: '01',
  //             name: '技术经理人'
  //         }
  //     ]
  // },
  {
    code: '06',
    name: '高校',
    category: 'shop',
    childs: [],
  },
  {
    code: '07',
    name: '动态',
    category: 'information',
    childs: [],
  },
];